import { API } from "."
import { makeParams } from "@/utils/helper"
import {
  ReadDevicesResponse,
  ReadMatchedDevicesResponse,
  ReadAssignableDevicesResponse,
  UpsertMatchPlayerAndDevicePayload,
} from "@/types/device"

/* 호출 시 interceptor 에서 /teams/{idfTeam} 추가 */

/* 기기 목록 조회 */
export async function readDevices() {
  return await API.get<ReadDevicesResponse>("/devices")
}

/* 연결된 기기 선수 목록 조회 */
export async function readMatchedDevices() {
  return await API.get<ReadMatchedDevicesResponse>("/devices/match")
}

/* 기기와 선수 매칭 */
export async function upsertMatchPlayerAndDevice(payload: UpsertMatchPlayerAndDevicePayload) {
  return await API.put<void>("/devices/match", payload)
}

/* 할당 가능 기기 목록 조회 */
export async function readAssignableDevices(idfPlayer?: number) {
  const params = makeParams({ idfPlayer })

  return await API.get<ReadAssignableDevicesResponse>("/devices/assignable", {
    params,
  })
}
